function openTabFromSizeChartButton() {
  let cta = document.querySelector('[data-charthandle]');

  if(cta){
    cta.addEventListener('click',(e)=>{
      
      if(window.matchMedia(window.themeVariables.mediaQueries['sm']).matches){
        let tab = document.querySelector(`[data-tabhandle="${cta.getAttribute('data-charthandle')}"]`);
        if (tab) {
          e.preventDefault();
          e.stopPropagation();
          tab.click();
          setTimeout(() => {
            tab.nextElementSibling.scrollIntoView({
              "behavior": "smooth",
              "block": "center"
            });
          }, 500);
        }
      }else{
        let accordion = document.querySelector(`[data-accordionhandle="${cta.getAttribute('data-charthandle')}"]`);
        if (accordion) {
          e.preventDefault();
          e.stopPropagation();
          accordion.setAttribute('aria-expandend', 'true');
          accordion.setAttribute('open', 'open');
          accordion.scrollIntoView({
            "behavior": "smooth",
            "block": "start"
          });
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', (e)=>{
  openTabFromSizeChartButton();
})